import React, { useState, useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "./styles/Home.css";
import Booking from "./Booking";
import Background from "../components/Background";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const Home = () => {

  const { loginWithRedirect, logout, isAuthenticated } = useAuth0();
  const [fadeIn, setFadeIn] = useState(false);
  const [darken, setDarken] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    setTimeout(() => setFadeIn(true), 1000); // Trigger fade-in after shrink animation
  }, []);

  return (
    <div className={`home-page ${darken ? "darken" : ""}`} ref={scrollRef}>
      {/* <div className="header-warning"><p>Please note that a $10 deposit will be due at the time of booking. Deposit is included in the total cost.</p></div> */}
      {/* < Navbar />
      < Background />
      <div className="gradient-overlay"></div> */}
      {!isAuthenticated ? (
        <>
          <button onClick={() => loginWithRedirect()}>Login</button>
          <button
            onClick={() =>
              loginWithRedirect({
                authorizationParams: { screen_hint: "signup" },
              })
            }
          >
            Signup
          </button>
        </>
      ) : (
        <>
          <div className={`fade-in ${fadeIn ? "show" : ""}`}>
            <Booking darken={darken} setDarken={setDarken} scrollRef={scrollRef} />
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
